export enum FORM_NAMES {
  AUTH_FORM = "auth_form",
}
